var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramAlert64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./Alert64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram",
    transform: "translate(17.000000, 7.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bell",
    transform: "translate(0.000000, 12.999492)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-6",
    fill: "#FFCC00",
    cx: 15,
    cy: 33.000508,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,7.500508 C5.08808225,3.29194065 9.12534446,0.000508 15,0.000508 C20.8746349,0.000508 24.9119118,3.29197018 27,7.500508 C27.6003788,8.71055742 28,11.1461903 28,12.500508 C28,16.4082732 28,21.4082732 28,27.500508 L30,32.000508 L14.999999,32.000508 L0,32.000508 L2,27.500508 C2.00000002,21.403981 2.00000002,16.403981 2,12.500508 C1.99999882,11.1462027 2.39963654,8.71055134 3,7.500508 Z",
    id: "Rectangle-11",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Emphasis",
    transform: "translate(2.000000, 0.500000)",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,6.500508 L13,0.500508",
    id: "Vertical-line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2068966,7.9410304 L25.3744637,3.62462165",
    id: "45-degree-line-right"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.79310345,7.9410304 L0.625536352,3.62462165",
    id: "45-degree-line-left"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramAlert64);
export default __webpack_public_path__ + "static/media/pictogramAlert64.97c0a7c5ea596581fbff695c63f224fe.svg";
export { ForwardRef as ReactComponent };